import React, { useState } from 'react'
import { useAddress, useMetamask, useSDK, useSigner } from '@thirdweb-dev/react'
import '../styles/card.css'
import check from '../assets/imgs/check-mark.png'
import Card3 from './Card3'
import { toast } from '../utils/toast'
import createSafetyCode from '../utils/getSafetyCode'

const Card = ({ mainAddr, burnerAddr, onClose }) => {
  const [showPopup, setShowPopup] = useState(false)
  const connectWithMetamask = useMetamask()
  const address = useAddress()
  const [isDone, setIsDone] = useState(false)
  const thirdwebSdk = useSDK()
  const signer = useSigner()
  const [mainSign, setMainSign] = useState('')

  const handleConnect = async () => {
    try {
      const connected = await connectWithMetamask()
      const connectedAddress = connected.data?.account || address

      if (connectedAddress.toLowerCase() !== mainAddr.toLowerCase()) {
        toast.error('Please connect to the main wallet address')
        return
      }
      const provider = thirdwebSdk.getProvider()
      const safetyCode = createSafetyCode(provider)
      const sigText = await window.Voxlink.getVoxlinkString(
        mainAddr,
        burnerAddr,
        safetyCode
      )
      const sign = await signer.signMessage(sigText)
      setMainSign(sign)
      setIsDone(true)
    } catch (error) {
      if (error.reason === 'user rejected signing') {
        toast.error('Please sign the transaction to continue')
        return
      }
      if (error.reason === 'user rejected request') {
        toast.error('Please connect to the main wallet address to continue')
        return
      }
      toast.error(`${error.message}`)
    }
  }

  const handleNext = () => {
    setShowPopup(true)
  }

  return (
    <>
      <div className="home_with_nav" onClick={onClose}></div>

      <div className={`Container_card ${showPopup ? 'hide-card' : ''}`}>
        <div className="leftside_card">
          <div className="left_top">
            <div className="step_tag">
              <h2>Step 2</h2>
            </div>
            <div className="connect_tag">
              <h1>
                Connect Your Main <br /> wallet
                <div className="container-dots">
                  <span className="dot"></span>
                  <span className="dot active"></span>
                  <span className="dot"></span>
                </div>
              </h1>
            </div>
          </div>

          <div className="end_next_step end_next_step-d">
            <div className="botton_top">
              <button
                className="button_box"
                onClick={handleNext}
                disabled={!isDone}
              >
                Next Step
              </button>
            </div>
            <div className="botton_down">
              <a href="">How it works?</a>
            </div>
          </div>
        </div>
        <div className="rightside_card">
          <div className="rightside_card_p">
            <p>Connect your main wallet and sign transaction</p>
          </div>
          <div className="connected_box">
            {isDone ? (
              <>
                <div>
                  <img src={check} />
                </div>
                <div>
                  <h1>Connected</h1>
                </div>
              </>
            ) : (
              <button className="connect_btn" onClick={handleConnect}>
                Connect Wallet
              </button>
            )}
          </div>
          <div className="address_section">
            <div className="">
              <p>Your main wallet address is:</p>
            </div>

            <h5>{mainAddr}</h5>
            <a href="">Not your address?</a>
          </div>
        </div>
      </div>

      {showPopup && (
        <Card3
          mainSign={mainSign}
          mainAddr={mainAddr}
          burnerAddr={burnerAddr}
        />
      )}
    </>
  )
}

export default Card
